<mwe-notification-banner emphasis="bold" [text]="text()" type="danger" />
